import type { FaireThemeEntity } from "../../entity_types/theme";

export const board_demo_r_9rhufegspe_thi_d2d140e565: FaireThemeEntity = {
  token: "board_demo_r_9rhufegspe_thi_d2d140e565",
  type: "theme",
  retailerToken: "r_9rhufegspe",
  name: "The Mystic Collection",
  description:
    "Elevate your spiritual jewelry selection with protective talismans and tarot-inspired pendants, reflecting your customers' love for mystical and symbolic pieces.",
  bgColor: "#F4EDE3",
  productTokens: [],
  coverImageUrl:
    "https://cdn.faire.com/fastly/94e6f5af8f088a0a3e1c6ae13f3315755c49171db1d1ac937a37ea86d6d7cbd5.jpeg",
  thumbnailImageUrls: [
    "https://cdn.faire.com/fastly/94e6f5af8f088a0a3e1c6ae13f3315755c49171db1d1ac937a37ea86d6d7cbd5.jpeg",
    "https://cdn.faire.com/fastly/7acf71d0e9274065f724eadd1b9e62f73b960ee27660d6ed45818de6defd38e7.jpeg",
    "https://cdn.faire.com/fastly/bde0cf7898f1b54290dc4e02c4d84c76139be851d5a606bcc9e7a67d5a062071.jpeg",
    "https://cdn.faire.com/fastly/aee55584f94a22f4870efdc760128be30bcd83b2925ea523efc31551b6b9e836.jpeg",
    "https://cdn.faire.com/fastly/b0f2ab9b270b9f618261253ed6ac77f3d82f3fe9ccba94fe77bc7b34b083e8bc.jpeg",
    "https://cdn.faire.com/fastly/f141ad049c8a1a83bbb58f462e0c94c22396d5bf4a03d8db5b124c063094239c.jpeg",
  ],
  itemCount: 38,
  source: "eric_themes_ideas",
  teaser: "thi_d2d140e565",
  meta: {
    source: "mock",
    importedAt: "2026-04-19T23:00:00.000Z",
    importedBy: "board-demo-canonicalize",
  },
};
